import { render, staticRenderFns } from "./TheUnitEdit.vue?vue&type=template&id=61081701&scoped=true&"
import script from "./TheUnitEdit.vue?vue&type=script&lang=js&"
export * from "./TheUnitEdit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "61081701",
  null
  
)

export default component.exports